import { render, staticRenderFns } from "./Statements.vue?vue&type=template&id=d2276bfe&scoped=true"
import script from "./Statements.vue?vue&type=script&setup=true&lang=ts"
export * from "./Statements.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Statements.vue?vue&type=style&index=0&id=d2276bfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2276bfe",
  null
  
)

export default component.exports